import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
      "paymentList", "refundList", "employeeList", 
      "vehicleList", "rowTemplate", "employeeRowTemplate", "vehicleRowTemplate",
      "row", "dispatchData", "surveyContent", "surveyDataContainer",
      "surveyAddressTemplate", "surveyRoomTemplate", "surveyItemTemplate"
    ]
  
  static values = {
    surveyData: Array,
  }

  connect() {
    this.paymentRows = []
    this.refundRows = []
    this.extractEmployees()
    this.extractVehicles()
    this.renderSurveyData()

    //console.log("surveyDataValue final invoc", this.surveyDataValue)
  }




  toggleSurveySection(event) {
    const content = this.surveyContentTarget
    content.classList.toggle('hidden')
    const icon = event.currentTarget.querySelector('i')
    icon.classList.toggle('fa-chevron-down')
    icon.classList.toggle('fa-chevron-up')
  }


  renderSurveyData() {
    const container = this.surveyDataContainerTarget
    container.innerHTML = ''

    this.surveyDataValue.forEach(survey => {
      const addressElement = this.surveyAddressTemplateTarget.content.cloneNode(true)
      addressElement.querySelector('[data-address-id]').textContent = survey.address_id

      const roomsContainer = addressElement.querySelector('[data-rooms-container]')
      
      survey.data.rooms.forEach(room => {
        const roomElement = this.surveyRoomTemplateTarget.content.cloneNode(true)
        roomElement.querySelector('[data-room-name]').textContent = room.category

        const itemsContainer = roomElement.querySelector('[data-items-container]')
        
        room.items.forEach(item => {
          const itemElement = this.surveyItemTemplateTarget.content.cloneNode(true)
          itemElement.querySelector('[data-item-name]').textContent = item.name
          itemElement.querySelector('[data-item-quantity]').textContent = item.qty
          itemElement.querySelector('[data-item-volume]').textContent = item.size
          itemsContainer.appendChild(itemElement)
        })

        roomsContainer.appendChild(roomElement)
      })

      container.appendChild(addressElement)
    })
  }





  addPaymentRow() {
    this.addRow(this.paymentListTarget, "payment")
  }

  addRefundRow() {
    this.addRow(this.refundListTarget, "refund")
  }

  addRow(listTarget, type) {
    const newRow = this.rowTemplateTarget.content.cloneNode(true)
    const rowElement = newRow.querySelector('[data-mover-final-invoice-target="row"]')
    if (rowElement) {
      rowElement.dataset.type = type
      rowElement.dataset.id = this.generateUniqueId()
    }
    listTarget.appendChild(newRow)

    this.updateState()
  }

  confirmRemoveRow(event) {
    const row = event.target.closest('[data-mover-final-invoice-target="row"]')
    if (row) {
      const type = row.dataset.type
      const confirmMessage = `Are you sure you want to delete this ${type}?`
      if (confirm(confirmMessage)) {
        this.removeRow(row)
      }
    }
  }

  removeRow(row) {
    row.remove()
    this.updateState()
  }

  updateState() {
    this.paymentRows = this.getRowsData(this.paymentListTarget)
    this.refundRows = this.getRowsData(this.refundListTarget)
    this.employeeRows = this.getEmployeeRowsData()
    this.vehicleRows = this.getVehicleRowsData()
    
    // Dispatch custom event with updated data
    this.dispatch("stateUpdated", { 
      detail: { 
        payments: this.paymentRows, 
        refunds: this.refundRows,
        employees: this.employeeRows,
        vehicles: this.vehicleRows
      } 
    })
  }

  getRowsData(listTarget) {
    return Array.from(listTarget.children).map(row => {
      const dateInput = row.querySelector('[data-mover-final-invoice-target="date"]')
      const typeSelect = row.querySelector('[data-mover-final-invoice-target="type"]')
      const amountInput = row.querySelector('[data-mover-final-invoice-target="amount"]')
      const notesTextarea = row.querySelector('[data-mover-final-invoice-target="notes"]')

      return {
        id: row.dataset.id,
        type: row.dataset.type,
        date: dateInput ? dateInput.value : '',
        paymentType: typeSelect ? typeSelect.value : '',
        amount: amountInput ? (parseFloat(amountInput.value) || 0) : 0,
        notes: notesTextarea ? notesTextarea.value : ''
      }
    })
  }

  getEmployeeRowsData() {
    return Array.from(this.employeeListTarget.querySelectorAll('tr')).map(row => {
      const nameElement = row.querySelector('[data-mover-final-invoice-target="employeeName"]')
      const positionElement = row.querySelector('[data-mover-final-invoice-target="employeePosition"]')
      const hoursInput = row.querySelector('[data-mover-final-invoice-target="employeeHours"]')
      const travelInput = row.querySelector('[data-mover-final-invoice-target="employeeTravel"]')
      const commissionInput = row.querySelector('[data-mover-final-invoice-target="employeeCommission"]')
      const bonusInput = row.querySelector('[data-mover-final-invoice-target="employeeBonus"]')
      const tipsInput = row.querySelector('[data-mover-final-invoice-target="employeeTips"]')

      return {
        name: nameElement ? nameElement.textContent : '',
        position: positionElement ? positionElement.textContent : '',
        hours: hoursInput ? (parseFloat(hoursInput.value) || 0) : 0,
        travel: travelInput ? (parseFloat(travelInput.value) || 0) : 0,
        commission: commissionInput ? (parseFloat(commissionInput.value) || 0) : 0,
        bonus: bonusInput ? (parseFloat(bonusInput.value) || 0) : 0,
        tips: tipsInput ? (parseFloat(tipsInput.value) || 0) : 0
      }
    })
  }

  getVehicleRowsData() {
    return Array.from(this.vehicleListTarget.querySelectorAll('tr')).map(row => {
      const nameElement = row.querySelector('[data-mover-final-invoice-target="vehicleName"]')
      const conditionSelect = row.querySelector('[data-mover-final-invoice-target="vehicleCondition"]')
      const mileageInput = row.querySelector('[data-mover-final-invoice-target="vehicleMileage"]')
      const fuelInput = row.querySelector('[data-mover-final-invoice-target="vehicleFuel"]')
      const interiorConditionSelect = row.querySelector('[data-mover-final-invoice-target="vehicleInteriorCondition"]')
      const exteriorConditionSelect = row.querySelector('[data-mover-final-invoice-target="vehicleExteriorCondition"]')

      return {
        name: nameElement ? nameElement.textContent : '',
        condition: conditionSelect ? conditionSelect.value : '',
        mileage: mileageInput ? (parseFloat(mileageInput.value) || 0) : 0,
        fuel: fuelInput ? (parseFloat(fuelInput.value) || 0) : 0,
        interiorCondition: interiorConditionSelect ? interiorConditionSelect.value : '',
        exteriorCondition: exteriorConditionSelect ? exteriorConditionSelect.value : ''
      }
    })
  }
 
  generateUniqueId() {
    return "xxyxx-xyxyx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  extractEmployees() {
    try {
      let dispatchData = this.dispatchDataTarget.value;
      //console.log('Raw dispatchData:', dispatchData);
      
      // Parse the JSON twice to handle double encoding
      dispatchData = JSON.parse(dispatchData);
      //console.log('Parsed dispatchData:', dispatchData);
      
      const uniqueEmployees = this.getUniqueEmployees(dispatchData);
      this.renderEmployees(uniqueEmployees);
    } catch (error) {
      console.error('Error extracting employees:', error);
    }
  }

  getUniqueEmployees(dispatchData) {
    //console.log('getUniqueEmployees input:', dispatchData);
    const employees = new Set();
    if (dispatchData && dispatchData.services) {
      Object.values(dispatchData.services).forEach(service => {
       // console.log('Processing service:', service);
        if (service.labor && Array.isArray(service.labor)) {
          service.labor.forEach(laborer => {
            employees.add(JSON.stringify({
              id: laborer.id,
              name: laborer.name,
              profilePictureUrl: laborer.profilePictureUrl
            }));
          });
        }
      });
    }

    const uniqueEmployees = Array.from(employees).map(JSON.parse);
    //console.log('Unique employees:', uniqueEmployees);
    return uniqueEmployees;
  }

  renderEmployees(employees) {
    //console.log('Rendering employees:', employees);
    const employeeList = this.employeeListTarget;

    employeeList.innerHTML = '';
    employees.forEach(employee => {
      const newRow = this.employeeRowTemplateTarget.content.cloneNode(true);
      const nameElement = newRow.querySelector('[data-mover-final-invoice-target="employeeName"]');
      const profilePictureElement = newRow.querySelector('[data-mover-final-invoice-target="employeeProfilePicture"]');
      
      if (nameElement) {
        nameElement.textContent = employee.name;
      }
      
      if (profilePictureElement) {
        profilePictureElement.src = employee.profilePictureUrl || '';
        profilePictureElement.alt = `${employee.name}'s profile picture`;
      }
      
      employeeList.appendChild(newRow);
    });

    this.updateState();
  }

  extractVehicles() {
    try {
      let dispatchData = this.dispatchDataTarget.value;
      //console.log('Raw dispatchData:', dispatchData);
      
      // Parse the JSON twice to handle double encoding
      dispatchData = JSON.parse(dispatchData);
      //console.log('Parsed dispatchData:', dispatchData);
      
      const uniqueVehicles = this.getUniqueVehicles(dispatchData);
      this.renderVehicles(uniqueVehicles);
    } catch (error) {
      console.error('Error extracting vehicles:', error);
    }
  }

  getUniqueVehicles(dispatchData) {
    //console.log('getUniqueVehicles input:', dispatchData);
    const vehicles = new Set();
    if (dispatchData && dispatchData.services) {
      Object.values(dispatchData.services).forEach(service => {
        //console.log('Processing service:', service);
        if (service.vehicles && Array.isArray(service.vehicles)) {
          service.vehicles.forEach(vehicle => {
            vehicles.add(JSON.stringify({
              id: vehicle.id,
              name: vehicle.name,
              profilePictureUrl: vehicle.profilePictureUrl,
              make: vehicle.make,
              model: vehicle.model,
              year: vehicle.year,
              licensePlate: vehicle.licensePlate
            }));
          });
        }
      });
    }

    const uniqueVehicles = Array.from(vehicles).map(JSON.parse);
    //console.log('Unique vehicles:', uniqueVehicles);
    return uniqueVehicles;
  }

  renderVehicles(vehicles) {
    //console.log('Rendering vehicles:', vehicles);
    const vehicleList = this.vehicleListTarget;

    vehicleList.innerHTML = '';
    vehicles.forEach(vehicle => {
      const newRow = this.vehicleRowTemplateTarget.content.cloneNode(true);
      const nameElement = newRow.querySelector('[data-mover-final-invoice-target="vehicleName"]');
      const profilePictureElement = newRow.querySelector('[data-mover-final-invoice-target="vehicleProfilePicture"]');
      
      if (nameElement) {
        nameElement.textContent = `${vehicle.name} (${vehicle.make} ${vehicle.model} ${vehicle.year})`;
      }
      
      if (profilePictureElement) {
        profilePictureElement.src = vehicle.profilePictureUrl || '';
        profilePictureElement.alt = `${vehicle.name}'s profile picture`;
      }
      
      vehicleList.appendChild(newRow);
    });

    this.updateState();
  }
}